<template>
  <div class="page-wrap">

    <!-- ── Page Header ── -->
    <div class="page-header">
      <div class="page-header__left">
        <button class="btn-back" @click="$router.back()">
          <i class="fa fa-arrow-left"></i>
        </button>
        <div>
          <h1 class="page-title">Edit Corporate</h1>
          <span class="page-subtitle" v-if="loaded">{{ corporate.name || corporate.user.email }}</span>
        </div>
      </div>
    </div>

    <div v-if="loaded">

      <!-- ── Contact Info ── -->
      <div class="panel">
        <div class="panel-title"><i class="fa fa-user"></i> Contact Info</div>
        <div class="form-grid">
          <div class="form-field">
            <label class="filter-label">First Name <span class="required">*</span></label>
            <input v-model="corporate.user.first_name" class="dd-input" placeholder="First name" required />
          </div>
          <div class="form-field">
            <label class="filter-label">Last Name</label>
            <input v-model="corporate.user.last_name" class="dd-input" placeholder="Last name" />
          </div>
          <div class="form-field">
            <label class="filter-label">Email <span class="required">*</span></label>
            <input v-model="corporate.user.email" type="email" class="dd-input" placeholder="email@company.com" required />
          </div>
          <div class="form-field">
            <label class="filter-label">Phone Number <span class="required">*</span></label>
            <input v-model="corporate.user.phone_number" class="dd-input" placeholder="+971..." required />
          </div>
        </div>
      </div>

      <!-- ── Company Info ── -->
      <div class="panel">
        <div class="panel-title"><i class="fa fa-building"></i> Company Info</div>
        <div class="form-grid">
          <div class="form-field">
            <label class="filter-label">Company Name <span class="required">*</span></label>
            <input v-model="corporate.name" class="dd-input" placeholder="Company name" required />
          </div>
          <div class="form-field">
            <label class="filter-label">Website URL</label>
            <input v-model="corporate.website" class="dd-input" placeholder="https://..." />
          </div>
          <div class="form-field">
            <label class="filter-label">Budget</label>
            <input v-model="corporate.budget" class="dd-input" placeholder="Budget" />
          </div>
        </div>
      </div>

      <!-- ── Services ── -->
      <div class="panel">
        <div class="panel-title"><i class="fa fa-list-ul"></i> Services Interested</div>
        <div class="services-checkboxes">
          <label v-for="svc in services" :key="svc" class="checkbox-label">
            <input
                type="checkbox"
                class="checkbox-input"
                :value="svc"
                v-model="corporate.services"
            />
            <span>{{ svc }}</span>
          </label>
        </div>
      </div>

      <!-- ── Address ── -->
      <div class="panel">
        <div class="panel-title"><i class="fa fa-map-marker"></i> Address</div>
        <div class="form-grid">
          <div class="form-field">
            <label class="filter-label">Country</label>
            <country-search-box
                :name="corporate.user.address && corporate.user.address.country ? corporate.user.address.country.name : ''"
                @selected="(id) => corporate.user.address.country_id = id"
            ></country-search-box>
          </div>
          <div class="form-field">
            <label class="filter-label">City</label>
            <city-search-box
                :country-id="corporate.user.address.country_id"
                :name="corporate.user.address && corporate.user.address.city ? corporate.user.address.city.name : ''"
                @selected="(id) => corporate.user.address.city_id = id"
            ></city-search-box>
          </div>
          <div class="form-field form-field--full">
            <label class="filter-label">Address</label>
            <input v-model="corporate.user.address.address" class="dd-input" placeholder="Street address" />
          </div>
          <div class="form-field">
            <label class="filter-label">Postcode</label>
            <input v-model="corporate.user.address.post_code" class="dd-input" placeholder="Postcode" />
          </div>
        </div>
      </div>

      <!-- Errors -->
      <ul class="error-list" v-if="corporate.errors && corporate.errors.length">
        <li v-for="error in corporate.errors" :key="error">{{ error }}</li>
      </ul>

      <!-- Save -->
      <div class="form-actions">
        <button class="btn-cancel" @click="$router.back()">
          <i class="fa fa-times"></i> Cancel
        </button>
        <button class="btn-save" @click.prevent="UpdateCorporate">
          <i class="fa fa-check"></i> Save Changes
        </button>
      </div>

    </div>

    <!-- Loading -->
    <div class="mt-5 pt-5">
      <loading v-if="!loaded"></loading>
    </div>

  </div>
</template>

<script>
import { config } from "../helpers";
import CountrySearchBox from "../components/CountrySearchBox.vue";
import CitySearchBox from "../components/CitySearchBox.vue";

export default {
  name: "CorporateEdit",
  components: {
    "country-search-box": CountrySearchBox,
    "city-search-box": CitySearchBox,
  },
  data() {
    return {
      id: this.$route.params.id,
      url: "",
      loaded: false,
      services: [
        "Rewards & Recognition", "Long Service Awards", "Motivation",
        "On Pack Promotions", "Corporate Gifts", "Team Building",
        "Sales Incentives", "Themed Incentives", "Corporate Hospitality",
        "Marketing Promotions", "Referral Schemes", "Employee Benefits", "Prizes",
      ],
      corporate: {},
    };
  },

  mounted() {
    this.url = config("BACKEND_ROOT") + "/admin/corporates";
    this.loadData();
  },

  methods: {
    loadData() {
      axios.get(`${this.url}/${this.id}`).then((r) => {
        const data = r.data.data;
        if (data.user.address != null) {
          data.user.address.country_id = data.user.address.country?.id ?? null;
          data.user.address.city_id    = data.user.address.city?.id ?? null;
        } else {
          data.user.address = { address: "", post_code: "", country: null, city: null, country_id: null, city_id: null };
        }
        this.corporate = data;
        this.loaded = true;
      });
    },

    UpdateCorporate(event) {
      event.preventDefault();
      axios
          .put(`${this.url}/${this.id}`, this.corporate)
          .then(() => this.$router.push("/corporates/"))
          .catch((e) => {
            this.$set(this.corporate, "errors", Object.values(e.response.data.errors).flat());
          });
    },
  },
};
</script>

<style scoped>
/* ══════════════════════════════════════
   Page
══════════════════════════════════════ */
.page-wrap { display: flex; flex-direction: column; gap: 16px; }

/* ── Header ── */
.page-header { display: flex; align-items: flex-start; gap: 12px; }
.page-header__left { display: flex; align-items: flex-start; gap: 12px; }
.btn-back { width: 34px; height: 34px; margin-top: 4px; background: var(--bg-hover); border: 1px solid var(--border); border-radius: 8px; color: var(--text-2); cursor: pointer; display: flex; align-items: center; justify-content: center; flex-shrink: 0; transition: border-color .15s, color .15s; }
.btn-back:hover { border-color: var(--accent); color: var(--accent); }
.page-title   { font-size: 20px; font-weight: 500; color: var(--text-1); margin: 0 0 2px; }
.page-subtitle { font-size: 12px; color: var(--text-3); }

/* ── Panel ── */
.panel { background: var(--bg-panel); border: 1px solid var(--border); border-radius: 12px; padding: 1.25rem; }
.panel-title { font-size: 12px; font-weight: 600; color: var(--text-3); text-transform: uppercase; letter-spacing: .5px; margin-bottom: 1.1rem; display: flex; align-items: center; gap: 7px; }

/* ── Form ── */
.form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.form-field { display: flex; flex-direction: column; gap: 5px; }
.form-field--full { grid-column: span 2; }
.filter-label { font-size: 11px; font-weight: 500; color: var(--text-3); text-transform: uppercase; letter-spacing: .4px; }
.required { color: var(--accent); }

.dd-input { height: 36px; background: var(--bg-base); border: 1px solid var(--border); border-radius: 8px; color: var(--text-1); font-size: 13px; padding: 0 10px; outline: none; width: 100%; transition: border-color .15s; }
.dd-input:focus { border-color: var(--accent); }
.dd-input::placeholder { color: var(--text-3); }

/* ── Services ── */
.services-checkboxes { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; }
.checkbox-label { display: flex; align-items: center; gap: 7px; cursor: pointer; font-size: 12px; color: var(--text-2); padding: 6px 8px; border-radius: 7px; border: 1px solid var(--border); background: var(--bg-hover); transition: border-color .15s, color .15s; }
.checkbox-label:hover { border-color: var(--accent); color: var(--text-1); }
.checkbox-input { accent-color: var(--accent); width: 14px; height: 14px; cursor: pointer; flex-shrink: 0; }

/* ── Errors ── */
.error-list { padding-left: 16px; color: var(--accent); font-size: 13px; }

/* ── Actions ── */
.form-actions { display: flex; justify-content: flex-end; gap: 8px; }
.btn-cancel { height: 38px; padding: 0 18px; background: var(--bg-hover); border: 1px solid var(--border); border-radius: 9px; color: var(--text-2); font-size: 13px; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: border-color .15s; }
.btn-cancel:hover { border-color: var(--border-2); }
.btn-save   { height: 38px; padding: 0 22px; background: var(--accent); border: none; border-radius: 9px; color: #fff; font-size: 13px; font-weight: 500; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: opacity .15s; }
.btn-save:hover { opacity: .88; }

/* ══════════════════════════════════════
   Responsive
══════════════════════════════════════ */
@media (max-width: 768px) {
  .form-grid { grid-template-columns: 1fr; }
  .form-field--full { grid-column: span 1; }
  .services-checkboxes { grid-template-columns: 1fr 1fr; }
}
</style>